import React from 'react';
import { CTAButton } from './CTAButton';
const metrics = [{
  value: '6',
  label: 'Teaching Volumes'
}, {
  value: '4',
  label: 'Professional Bonuses'
}, {
  value: '420+',
  label: 'Pages of Content'
}, {
  value: '🌎',
  label: 'Worldwide'
}];
export function Hero() {
  return <section className="w-full bg-navy px-5 pb-12 pt-10 sm:pb-20 sm:pt-16" data-id="element-95" data-mp="4lyv8luf2edn">
      <div className="mx-auto flex max-w-3xl flex-col items-center text-center" data-id="element-96" data-mp="4jvvvb7dj8w9">
        <span className="mb-6 inline-block rounded-full border border-gold bg-gold/10 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-wider text-gold" data-id="element-97" data-mp="128pijeo72z53">
          🎓 Premium Digital System for ESL &amp; EFL Teachers Worldwide · 2026 Edition
        </span>
        <h1 className="font-display text-[24px] font-bold leading-tight text-white sm:text-5xl md:text-6xl" data-id="element-98" data-mp="nczvreb6qhzb">
          Stop spending your Sundays planning lessons. Have them ready in 5 minutes.
        </h1>
        <figure className="relative mt-8 w-full max-w-[680px] sm:mt-10" data-id="element-99" data-mp="381e0l9runzsg">
          <div className="relative overflow-hidden rounded-[26px] bg-navy-mid shadow-[0_20px_45px_-22px_rgba(0,0,0,0.8)]" data-id="element-100" data-mp="3j7zfnjujfuh7">
            <img src="https://cdn.magicpatterns.com/uploads/dMahrep7F4sfsvQD3fZvZy/mockup_esl_ingles.webp" alt="ESL teacher confidently using The ESL Survival Vault system at their desk" width="680" height="382" loading="eager" decoding="sync" className="block aspect-[16/9] w-full object-cover" data-id="element-101" data-mp="3o6khfnpfum7r" />
            <div className="pointer-events-none absolute inset-0 rounded-[26px] ring-1 ring-inset ring-gold/55" aria-hidden="true" data-id="element-102" data-mp="359j8jrsrk1yj" />
          </div>
          <figcaption className="px-3 pt-3 text-center text-xs font-medium text-white/75" data-id="element-103" data-mp="2vjzoiitbe223">
            The complete system, ready for your next class.
          </figcaption>
        </figure>
        <p className="mt-6 max-w-xl text-[12px] text-white/75 sm:text-base" data-id="element-104" data-mp="2ll0gn2gdiag5">
          6 Teaching Volumes + 4 Professional Bonuses. 420+ pages of ready-to-use content organized
          by A1, A2, and B1 levels. Available for instant download worldwide.
        </p>
        <div className="mt-8 w-full max-w-md" data-id="element-105" data-mp="ic86patlvyvq">
          <CTAButton label="YES, I WANT THE COMPLETE SYSTEM" data-id="element-106" data-mp="id02aln7dwm0" />
          <p className="mt-3 text-xs text-white/65 sm:text-sm" data-id="element-107" data-mp="ddf4iejrruav">
            Instant PDF Download · One-Time Payment · No Subscription
          </p>
          <p className="mt-2 text-xs font-medium text-gold" data-id="element-108" data-mp="1b0dt020b5vxo">
            💱 The platform automatically converts to your local currency
          </p>
        </div>
        <div className="mt-7 grid w-full grid-cols-2 overflow-hidden rounded-2xl border border-gold bg-steel sm:mt-9 sm:grid-cols-4" data-id="element-109" data-mp="1126mkd3naw9x">
          {metrics.map((metric, index) => <div key={metric.label} className={`flex flex-col items-center px-4 py-5 sm:py-6 ${index % 2 !== 0 ? 'border-l border-gold/45' : ''} ${index >= 2 ? 'border-t border-gold/45' : ''} sm:border-l sm:border-t-0 sm:first:border-l-0`} data-id="element-110" data-mp="3lsp1j88sy9bs" data-mpi={index}>
              <span className="font-display text-4xl font-bold text-gold" data-id="element-111" data-mp="21aejxk2ygrc7">{metric.value}</span>
              <span className="mt-1 text-xs font-semibold text-white sm:text-sm" data-id="element-112" data-mp="269he29hedd5e">
                {metric.label}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}